import { KM, RE } from "country-flag-icons/react/3x2";
import { TIMEOUT } from "dns";

const esJSON = {
  LOGO: {
    VERSION: '1.0',
    VERSION_DESC: 'Primera versión',
    SYSTEM_NAME: 'Citas Tránsito Chihuahua'
  },
  MY_ACCOUNT: {
    HEADING: "Mi cuenta",
    SUBHEADING: "Información general y configuración de la cuenta",
    USER_DETAILS: "Detalles del usuario",
    USER_DETAILS_DESCRIPTION: "Administra la información de usuario",
    BTN_CHANGE_PASSWORD: "Cambiar contraseña",
    BTN_EDIT: "Editar",
    ACCOUNT_EDIT: "Editar perfil",
    ACCOUNT_EDIT_DESCRIPTION: "Formulario de edición del perfil",
    PROFILE_INFO_UPDATED: "Se ha actualizado la información del perfil",
    PROFILE_INFO_UPDATED_WITH_ERROR: "Se ha actualizado la información del perfil, pero, ocurrió un error al mostrar los datos actualizados.",
    CHANGE_PASSWORD_HEADING: "Cambiar contraseña",
    CHANGE_PASSWORD_SUBHEADING: "Formulario para cambiar la contraseña",
  },
  LOGIN: {
    HEADING: "Iniciar sesión",
    SUBHEADING: "Rellena los campos a continuación para iniciar sesión",
    REGISTER: "Registrarse",
    DONT_YOU_HAVE_AN_ACCOUNT: "¿No tienes una cuenta?",
    LOST_PASSWORD: "¿Olvidaste tu contraseña?"
  },
  REGISTER: {
    HEADING: "Registrar cuenta",
    SUBHEADING: "Completa los campos a continuación para crear una cuenta nueva.",
    BACK_TO: "Regresar a",
    USER_REGISTERED: "Se ha registrado el usuario"
  },
  LANGUAGE_SWITCHER: {
    HEADING: "Lenguage",
    SUBHEADING: "Cambia el lenguaje"
  },
  RECOVER_PASSWORD: {
    HEADING: "Recuperar contraseña",
    SUBHEADING: "Introduce tu correo electrónico para reiniciar tu contraseña",
    BACK_TO_LOGIN: "Quieres volver a iniciar sesión?",
    INSTRUCTIONS: "Las instrucciones para recuperar tu contraseña se han enviado a tu correo electrónico.",
    CHECK_MAIL: "Revisa tu correo electrónico para recuperar tu contraseña",
    TO_LOGIN: "Ir a iniciar sesión"
  },
  ROLES: {
    HEADING: "Roles",
    SUBHEADING: "Administración de los roles y permisos",
    CREATE: "Crear rol",
    CREATE_DESC: "Completa el formulario para crear un rol",
    EDIT: "Editar rol",
    EDIT_DESC: "Completa el formulario para editar el rol",
    SHOW: "Detalles del rol",
    SHOW_DESC: "Información completa del rol seleccionado",
    DELETE: "Borrar rol",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el rol seleccionado?",
    DELETED: "Se ha borrado el rol seleccionado",
    SEARCH: "Buscar por nombre o descripción",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado el rol.",
    EDITED: "Se ha editado el rol."
  },
  USERS: {
    HEADING: "Usuarios",
    SUBHEADING: "Administración de los usuarios",
    CREATE: "Crear usuario",
    CREATE_DESC: "Completa el formulario para crear un usuario",
    EDIT: "Editar usuario",
    EDIT_DESC: "Completa el formulario para editar el usuario",
    SHOW: "Detalles del usuario",
    SHOW_DESC: "Información completa del usuario seleccionado",
    DELETE: "Borrar usuario",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el usuario seleccionado?",
    DELETED: "Se ha borrado el usuario seleccionado",
    SEARCH: "Buscar por nombre de usuario o correo electrónico",
    ACTIVE: {
      0: 'Desctivado',
      1: 'Activado'
    }
  },
  RESET_PASSWORD: {
    HEADING: "Reiniciar contraseña",
    SUBHEADING: "Llena los campos para reiniciar tu contraseña",
    INSTRUCTIONS: "Ahora puedes iniciar sesión con tu nueva contraseña",
    SUCCESS: "Se ha reiniciado la contraseña",
    TO_LOGIN: "Ir a iniciar sesión"
  },
  EMAIL_VERIFICATION: {
    HEADING: "Verificación de correo",
    SUBHEADING: "Es necesario verificar tu correo electrónico para el uso del sistema. \n Al momento de registrarte se ha enviado un correo de verificación, en caso de no haberlo recibido puedes solicitar otro pulsando el siguiente botón.",
    BUTTON: "Solicitar un correo de verificación",
    SUCCESS: "Se ha enviado el correo de verificación a la dirección registrada"
  },
  VERIFY_EMAIL: {
    HEADING: "Verificación de correo",
    SUBHEADING: "Es necesario que el correo electrónico sea verificado para hacer uso del sistema",
    VERIFYING: "Verificando correo electrónico",
    VERIFIED: "Se ha verificado el correo electrónico con éxito, serás redirigido al inicio",
    VERIFIED_ERROR: "Hubo un error verificando tu correó electrónico, puedes solicitar un nuevo correó de verificacón en el siguiente botón",
    VERIFY: "Verificar correo electrónico",
    BUTTON: "Ir a solicitar un correo de verificación"
  },
  THEME_SETTINGS: {
    CHOOSE_LAYOUT: "Selecciona la distribución",
    CHOOSE_THEME: "Selecciona el tema",
    ADMIN_PANEL_LAYOUT: "Distribución del panel de administrador",
    ADMIN_PANEL_LAYOUT_DESCRIPTION: "Cambia el acomodo de la información",
    ADMIN_PANEL_THEME: "Tema del panel de administrador",
    ADMIN_PANEL_THEME_DESCRIPTION: "Cambia los colores",
    THEMES: {
      PURE_LIGHT_THEME: "Pure Light",
      GRAY_GOOSE_THEME: "Gray Goose",
      PURPLE_FLOW_THEME: "Purple Flow"
    },
    LAYOUTS: {
      EXTENDED_SIDEBAR: "Extended Sidebar",
      ACCENT_HEADER: "Accent Header",
      ACCENT_SIDEBAR: "Accent Sidebar",
      BOXED_SIDEBAR: "Boxed Sidebar",
      COLLAPSED_SIDEBAR: "Collapsed Sidebar",
      BOTTOM_NAVIGATION: "Bottom Navigation",
      TOP_NAVIGATION: "Top Navigation"
    },
  },
  FIELDS: {
    USERNAME: "Usuario",
    EMAIL: "Correo electrónico",
    NAME: "Nombre",
    LASTNAME: "Apellido",
    CURRENT_PASSWORD: "Contrseña actual",
    PASSWORD: "Contraseña",
    PASSWORD_CONFIRMATION: "Confirmación de contraseña",
    REMEMBER: "Recuerdame",
    DESCRIPTION: "Descripción",
    ID: "Id",
    CREATED_AT: "Creado",
    UPDATED_AT: "Actualizado",
    ROLE: "Rol",
    ROLE_ID: "Rol",
    ACTIVE: "Estado",
    EMAIL_VERIFIED_AT: 'Verificado',
    MUNICIPALITY: 'Municipio',
    QUOTES: "Citas",
    WEEKS: "Se repite",
    OPENING_TIME: "Hora de apertura",
    CLOSING_TIME: "Hora de cierre",
    MODULE: 'Módulo',
    LICENCE_TYPE: 'Tipo de licencia',
    FORMALITY: 'Trámite',
    ALL: "Todos",
    ALL_POSSIBLE_TIMES: "Todas las veces posibles",
    AND: " y ",
    DATE_AVAILABILITY_DETAILS: "Disponibilidad de citas",
    AVAILABLE_DAYS: "Disponibilidad de citas",
    LAST_NAME: "Primer Apellido",
    SECOND_LAST_NAME: "Segundo Apellido",
    CURP: "CURP",
    ADDRESS: "Dirección",
    RFC: "RFC",
    SEX: "Sexo",
    BIRTHDATE: "Fecha de nacimiento",
    MARITAL_STATUS: "Estado civil",
    NATIONALITY_ID: "Nacionalidad",
    NATIONALITY: "Nacionalidad",
    PHONE: "Teléfono",
    OCCUPATION: "Ocupación",
    EMERGENCY_CONTACT: "Contacto de emergencia",
    MINOR_TUTOR: "Tutor",
    CITIZEN_FOREIGNS: "Extranjeros",
    FOLIO_ID: 'Folio',
    DATE: 'Fecha',
    TIME: 'Hora',
    ASSISTANCE: 'Asistencia',
    APPOINTMENT_TYPE: 'Estado',
    DAY: "Día",
    ALL_EXCEPT_FIRST_TIME: "Todos excepto primera vez",
    USER: 'Usuario',
    TABLE: 'Tabla modificada',
    INI_DATE: 'Fecha de inicio',
    FIN_DATE: 'Fecha final',
    AFTER: 'Guardado',
    BEFORE: 'Antes de guardar',
    DATE_AVAILABILITY_DETAILS_EXCEPTION: 'Excepciones en disponibilidad de citas',
    WEEKS_ON_REPIT: 'Semanas que se repite',
    SCHEDULE: 'Horario:',
    APPOINTMENTS_QUANTITY: 'Cantidad de citas',
    NO_FILTER: 'Sin filtrar',
  },
  VALIDATION: {
    REQUIRED: "El campo es requerido.",
    EMAIL: "El campo debe ser un correo electrónico válido.",
    MIN_ONE: "Es necesario seleccionar al menos 1.",
    MAX_OPENING_TIME: "La hora de apertura debe ser menor a la hora de cierre",
    MIN_CLOSING_TIME: "La hora de cierre debe ser mayor a la hora de apertura"
  },
  GENERAL: {
    CANCEL: "Cancelar",
    LOGOUT: "Cerrar sesión",
    CLOSE: "Cerrar",
    NO_RESULTS: "No se han encontrado resultados",
    SEARCH: "Buscar",
    ACTIONS: "Acciones",
    GO_TO_HOMEPAGE: "Volver a inicio",
    BULK_ACTIONS: "Acciones masivas",
    BULK_DELETE: "Borrar seleccionados",
    SELECT_BETWEEN_VIEWS: "Selecciona la distribución para mostrar la lista entre una tabla y tarjetas.",
    RESET: 'Reiniciar formulario',
    ENABLE: "Activo",
    DISABLED: "Desactivado"
  },
  STATUS: {
    404: {
      MESSAGE: "La página que buscas no existe."
    },
    403: {
      MESSAGE: "No estás autorizado para realizar esta acción."
    },
    401: {
      MESSAGE: "No se ha iniciado sesión o la sesión ha caducado"
    }
  },
  SETTINGS: {
    HEADING: 'Configuración',
    SUBHEADING: 'Configuración del sistema',
    CREATE: "Crear usuario",
    CREATE_DESC: "Completa el formulario para crear un usuario",
    EDIT: "Editar usuario",
    EDIT_DESC: "Completa el formulario para editar el usuario",
    SHOW: "Detalles del usuario",
    SHOW_DESC: "Información completa del usuario seleccionado",
    DELETE: "Borrar usuario",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el usuario seleccionado?",
    DELETED: "Se ha borrado el usuario seleccionado",
    SEARCH: "Buscar por nombre de usuario o correo electrónico",
    SYSTEM_ADDRESSES_UPLOAD: 'Excel de códigos postales',
    SYSTEM_ADDRESSES_UPLOAD_DESC: 'Es necesario importar el archivo de códigos postales, puedes encontrarlo en el siguiente enlace: ',
    ADDRESSES: 'Códigos postales',
    SYSTEM_ADDRESSES_SUBMIT: 'Guardar archivo'
  },

  "LICENCE-TYPES": {
    HEADING: 'Tipos de licencia',
    SUBHEADING: 'Diferentes tipos de licencia',
    CREATE: "Crear tipo de licencia",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar tipo de licencia",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  MODULES: {
    HEADING: 'Módulos',
    SUBHEADING: 'Configuración de módulos',
    CREATE: "Crear módulo",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar el módulo",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  FORMALITIES: {
    HEADING: 'Trámites',
    SUBHEADING: 'Lista de trámites',
    CREATE: "Crear trámite",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar trámite",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  IDENTIFICATIONS: {
    HEADING: 'Identificaciones',
    SUBHEADING: 'Lista de identificaciones',
    CREATE: "Crear identificación de ciudadano",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar identificacion de ciudadano",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  "ADDRESS-VERIFICATION-DOCUMENTS": {
    HEADING: 'Documentos de verificación',
    SUBHEADING: 'Lista de documentos de verificación',
    CREATE: "Crear documento de verificación",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar documento de verificación",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  NATIONALITIES: {
    HEADING: 'Nacionalidades',
    SUBHEADING: 'Lista de nacionalidades',
    CREATE: "Crear nacionalidad",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar nacionalidad",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  "DATES-AVAILABILITY": {
    HEADING: "Disponibilidad de citas",
    SUBHEADING: 'Disponibilidad de citas en los modulos',
    CREATE: "Agregar disponibilidad de citas",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar disponibilidad de citas",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    ERROR:"Hubo un error al obtener los datos necesarios para crear una disponibilidad de cita.",
    ERROR_AVAILABILITY:"Hubo un error al obtener los datos necesarios para los filtros.",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar",
    'WEEKS-TEXT': {
      1: "Primera semana",
      2: "Segunda semana",
      3: "Tercera semana",
      4: "Cuarta semana",
    },
    'DAY-TEXT': {
      Mon: 'Lunes',
      Tue: 'Martes',
      Wed: 'Miércoles',
      Thu: 'Jueves',
      Fri: 'Viernes',
      Sat: 'Sábado',
      Sun: 'Domingo'
    },
    ADD_AVAILABILITY: "Agregar disponibilidad",
    FILTERS: "Filtros",
    CLEAR_FILTERS: "Limpiar filtros"
  },
  CITIZENS: {
    HEADING: 'Ciudadanos',
    SUBHEADING: 'Lista de ciudadanos',
    CREATE: "Registrar ciudadano",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar ciudadano",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  APPOINTMENTS: {
    HEADING: 'Listado de citas',
    SUBHEADING: 'Lista de citas registradas',
    SEARCH: 'Buscar por folio, curp o nombre',
    EXPORT: 'Exportar a excel'
  },
  DASHBOARD: {
    HEADING: 'Listado de citas'
  },
  "NONWORKING-DAYS": {
    HEADING: 'Días no laborales',
    SUBHEADING: 'Lista de días no laborales',
    CREATE: "Registrar día no laboral",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar día no laboral",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar"
  },
  "CHANGE-LOG": {
    HEADING: 'Historial de cambios',
    SUBHEADING: 'Historial de cambios registrados',
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
  },

  "DATES-AVAILABILITY-EXCEPTION": {
    HEADING: "Excepcion en disponibilidad de citas",
    SUBHEADING: 'Excepciones en la disponibilidad de citas en los modulos',
    CREATE: "Agregar excepcion en disponibilidad de citas",
    CREATE_DESC: "Completa el formulario",
    EDIT: "Editar excepcion en disponibilidad de citas",
    EDIT_DESC: "Completa el formulario para editar",
    SHOW: "Detalles",
    SHOW_DESC: "Información completa",
    DELETE: "Borrar",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el elemento?",
    DELETED: "Se ha borrado el elemento seleccionado",
    SEARCH: "Buscar",
  },

  "DUPLICATED-APPOINTMENT":{
    TITLE: "Cita ya programada para este tipo de licencia",
    INFO:"Usted ya cuenta con una cita programada para éste tipo de licencia de conducir, puede cancelar su cita al inicio de ésta página seleccionando el trámite \"CANCELAR CITA\", capturando su folio de cita que se encuentra en su hoja de confirmación que le fue enviada por correo, y después puede programar una nueva cita, o si requiere más información puede comunicarse al teléfono:",
    CONTACT_DATA_RENOVATION:"Renovación de licencia:",
    CONTACT_DATA_RENOVATION_CH:"Cd. Chihuahua: 614 429 3300 Ext. 20511",
    CONTACT_DATA_RENOVATION_JU:"Cd. Juárez: 656 629 3300 Ext. 55254",
    CONTACT_DATA_FIRSTIME: "Licencia por primera vez:",
    CONTACT_DATA_FIRSTIME_CH: "Cd. Chihuahua: 614 429 3300 Ext. 20963 y 20964",
    CONTACT_DATA_FIRSTIME_JU: "Cd. Juárez: 656 629 3300 Ext. 55254",
    BUTTON: "Aceptar"
  },

  "DAYS":{
    MONDAY: "Lunes",
    TUESDAY: "Martes",
    WEDNESDAY: "Miércoles",
    THURSDAY: "Jueves",
    FRIDAY: "Viernes",
    SATURDAY: "Sabado",
    SUNDAY: "Domingo"
  },

  "HOME":{
    WELCOME: "¡Bienvenido!",
    SUBHEADING: "Estás realizando un trámite para tu licencia de conducir:",
    START: "Comenzar",
    TIMEOUT: "!Tiempo agotado!",
    TIMEOUT_MESSAGE: "Se agotó el tiempo disponible para agendar tu cita. Porfavor, inténtalo de nuevo.",
    BACK_HOME: "Volver a inicio",
    ERROR_FORM: "Hubo un error al obtener los datos necesarios para el formulario.",
    PROCESS: "Proceso",
    TIME_REMAINING: "Tiempo restante para agendar cita:",
    SELECT_PROCEDURE: "Selecciona el trámite que deseas realizar",
    FIRST_TIME: "Primera vez",
    RENEWAL: "Renovación",
    EXCHANGE: "Canje",
    LOST:"Extravio",
    STOLEN:"Robo",
    FOREIGNERS:"Extranjeros",
    NON_LOCALS:"Foráneos",
    TRANSPORT:"Transportes",
    CANCEL_APPOINTMENT:"Cancelar cita",
    DRAG_FILE: "Arrastra los archivos para cargarlos",
    DONT_ALLOWED_FILES: "No puedes cargar este tipo de archivos",
    DRAG_DROP_FILE: "Arrastra y suelta el archivo aquí",
    FIRST_TIME_DESCRIPTION: "Trámite de licencia de conducir por primera vez.",
    RENEWAL_DESCRIPTION: "Trámite de renovación de licencia de conducir.",
    EXCHANGE_DESCRIPTION: "Trámite para el canje de licencia vigente.",
    LOST_DESCRIPTION: "Trámite para el canje de una licencia extraviada.",
    STOLEN_DESCRIPTION: "Trámite para el canje de una licencia que ha sido robada.",
    FIRST_TIME_DESCRIPTION2: "Trámite de licencia de conducir por primera vez en el estado de Chihuahua.",
    TRANSPORT_DESCRIPTION: "Trámite de licencia para transporte público.",
    SERVICE_PHONE: "Por favor comuníquese a la Dirección de Transportes del Estado al tel. 429.33.00 ext. 24909 y 24913 para más información.",
    SELECT_LICENSE_TYPE: "Seleccione el tipo de licencia",
    SELECT_MODULE: "Seleccione el módulo de su ciudad",
    SELECT_DATE: "Seleccione una fecha disponible",
    SELECTED: "Seleccionado",
    AVAILABLE: "Disponible",
    UNAVAILABLE: "Cupo lleno",
    NO_WORKING_DAY: "Día sin servicio",
    SELECT_HOUR: " Seleccione la hora de cita",
  },

  "ERRORS": {
    NOT_VALID_CURP: "El CURP no es válido",
    NOT_VALID_NAME: "El nombre no es válido, no introduzca simbolos ni espacios al final del nombre",
    NOT_VALID_LASTNAME: "El apellido no es válido, no introduzca simbolos ni espacios al final del nombre",
    ONLY_ONE_LASTNAME: "Si solo cuenta con un apellido, introdúzcalo en el campo Primer Apellido",
    RFC_NOT_VALID: "El RFC no es válido",
    NOT_VALID_DATE: "La fecha no es válida",
    DATE_CURP_NOT_MATCHING: "La fecha no coincide con la de la curp",
    NOT_VALID_PHONE: "El teléfono no es válido",
    ZIP_CODE_NOT_VALID: "El código postal no es válido",
    RFC_NOT_MATCHES_CURP: "El RFC no coincide con la CURP",
    PASSWORD_CHANGED: "Su contraseña se ha cambiado.",
    MAKE_APPOINTMENT: "Hubo un error al apartar la cita.",
    MINOR_ERROR: "Favor de seleccionar la licencia correcta, se seleccionó menor de edad",
    ADULT_ERROR:"Favor de seleccionar la licencia correcta, se seleccionó mayor de edad",
    MINOR_DONT_ALLOWED: "Los menores de 16 años no pueden trámitar licencias",
    MINOR_TUTOR_DONT_ALLOWED: "Los menores de 18 años no pueden ser tutores",
    ERROR_GENERATING: "Hubo un error generando la cita",
    ID:"Identificación oficial (INE, pasaporte mexicano, cartilla militar, cédula profesional), en el caso de menores de edad: credencial escolar vigente, pasaporte mexicano vigente, y tendrá que presentarse con papá, mamá o tutor legal y la identificación del mismo.",
    MAX_LENGTH_EXCEEDED: "Se ha excedido el número de caracteres permitidos.",
  },

  "BLOCK_1": {
    REQUIREMENTS_DESCRIPTION:"El solicitante  deberá presentar los siguientes requisitos en original:",
    BIRTH_CERTIFICATE: "Acta de nacimiento (Original)",
    PAYMENT_RECEPT:"Comprobante de pago de validación de aptitudes teóricas y prácticas de conducción de vehículos",
    MOTORCYCLE_REQUIREMENTS:"En caso de licencia para motociclista presentar (moto y casco) únicamente en Chihuahua capital",
    TUTOR:" Padre, madre o tutor legal acudir con identificación oficial y copia de la misma.",
    IMPORTANT_MESSAGES: "MENSAJES IMPORTANTES",
    ON_TIME:" Presentarse 30 minutos antes de su cita, ya que la misma caduca en el momento de cumplirse.",
    PRINT_APPOINTMENT: "Para recibir atención es indispensable contar con su cita impresa y/o digital (Este documento) y portar una identificación oficial vigente con fotografía y firma.",
    REQUIREMENTS_CHECK: "Es importante cumplir con todos los requisitos de acuerdo a lo establecido de su cita.",
    PAYMENT_INFO: "Deberá pagar curso de validación de aptitudes teóricas y prácticas de conducción de vehículos",
    WHERE_PAY:"El pago del curso se puede realizar el mismo día de su cita en las cajas de Recaudación de Rentas de las mismas instalaciones.",
    ID:"Identificación oficial (INE, pasaporte mexicano, cartilla militar, cédula profesional), en el caso de menores de edad: credencial escolar vigente, pasaporte mexicano vigente, y tendrá que presentarse con papá, mamá o tutor legal y la identificación del mismo.",
    ON_TIME_SHORT_DESCRIPTION: "Presentarse 30 minutos antes de su cita.",
    MANDATORY_TEST: "El solicitante deberá presentarse al curso de conducción y aprobar las evaluaciones teórico/práctico en el departamento de educación vial.",
    BLOOD_TYPE: "Es importante CONOCER tu tipo de sangre.",
  },

  "BLOCK_6": {
    HEADING: "Licencia de conducir para extranjeros",
    SUBHEADING: "Trámite de licencia de conducir para extranjeros.",
    BLOOD_TYPE: "Para realizar cualquier trámite, deberás de CONOCER tu CURP y tu tipo de sangre.",
    REQUIREMENTS: "El solicitante extranjero deberá presentar los siguientes requisitos en original:",
    PASSPORT: "Pasaporte del país de origen",
    TEMPORARY_RESIDENCE: "Residencia temporal o permanente (FM2 o FM3)",
    TEMPORARY_LICENSE: "Permiso temporal: Presentar pasaporte de su país, acreditar domicilio y su licencia se autoriza solo por 1 ó 3 años.",
    PERMANENT_LICENSE: "Permiso permanente: Licencia anterior, permiso permanente, acreditar domicilio y su licencia se le autoriza hasta por 6 años.",
    THEORETICAL_TEST: "Sujeto a realizar examen teórico practico, en caso de primera vez debe realizar su trámite en la opción de \"Primera Vez\"",
    ADDRESS_PROOF: "Comprobante de domicilio",
    ADDRESS_PROOF_DESCRIPTION: "Comprobante de domicilio oficial a nombre del interesado, fecha reciente (agua, luz, gas natural, predial o teléfono activo). En caso de no estar a su nombre, acompañarlo de algún estado de cuenta bancario o de tiendas departamentales con el mismo domicilio del recibo oficial y/o carta de resolución de Migración. En caso de los menores de edad presentar comprobante de domicilio a nombre del tutor legal",
    PARTICULAR_DRIVER: "Automovilista particular",
    PARTICULAR_DRIVER_DESCRIPTION: "Autoriza al interesado a conducir vehículos particulares hasta de doce plazas, o de carga particular cuyo peso máximo autorizado no exceda de 3.5 Toneladas.",
    PARTICULAR_COMMERCIAL_DRIVER: "Chofer particular",
    PARTICULAR_COMMERCIAL_DRIVER_DESCRIPTION: "Autoriza al interesado a conducir vehículos particulares destinados al transporte hasta veintidós plazas y un peso máximo de diez toneladas.",
    MOTORCYCLE: "Motociclista",
    MOTORCYCLE_DESCRIPTION: "Autoriza al interesado a manejar cualquier tipo de motocicleta.",
    ARTICLE_LAW:" De acuerdo al artículo 54 de la Ley de Vialidad y Tránsito para el Estado de Chihuahua vigente.",
  },

  "PREFIXES":{
    STREET:"C.",
    AVENUE:"Ave.",
    BOULEVARD:"Blvd.",
    ALLEY:"Callejon",
    ROAD:"Camino",
    HIGHWAY_KM:"km-Highway",
    PRIVATE_STREET:"Priv.",
    CONOCIDO:"Conocido",
    INDUSTRIAL_PARK:"Par-Ind",
    BELTWAY:"Perif.",
    CUL_DE_SAC: "Cerrada",
  },

  "FINAL":{
    WARNING: "¡Advertencia!",
    COMPLETE_FORM: "Llena el formulario",
    ADDRESS_DATA: "Datos de dirección",
    PREFIX: "Prefijo",
    STREET: "Calle",
    EXTERNAL_NUMBER: "Número exterior",
    INTERNAL_NUMBER: "Número interior",
    ZIP_CODE: "Código postal",
    STATE: "Estado",
    MUNICIPALITY: "Municipio",
    NEIGHBORHOOD: "Colonia",
    NAME: "Nombre(s)",
    FIRST_LASTNAME: "Primer apellido",
    SECOND_LASTNAME: "Segundo apellido",
    PHONE:"Teléfono",
    EMAIL:"Correo electrónico",
    SEX: "Sexo",  
    BIRTHDATE: "Fecha de nacimiento",
    CIVIL_STATUS:"Estado civil",
    OCCUPATION: "Ocupación",
    NATIONALITY: "Nacionalidad",
  },

  OCCUPATIONS:{
    STUDENT: "Estudiante",
    EMPLOYEE: "Empleado",
    UNEMPLOYED: "Desocupado",
    HOUSEWIFE: "Ama de casa",
    RETIRED: "Jubilado",
    SELF_EMPLOYED: "Independiente",
  },
};

export default esJSON;
